import React, { useState, useEffect } from "react";
import { useSelector } from "react-redux";
import OrganisationListScreen from "./brandSetiing/organisationListScreen.js";
import { PrimaryCta, FallBack, CampaignListDropdown } from "../components";
import Core from "../common/clientSdk.js";
import CustomTable from "../components/customTable";
import SideMenu from "./sideMenu";
import Header from "./header";
import Utils from "../common/utils.js";
import { useNavigate, useSearchParams } from "react-router-dom";
import { Loader } from "./loader";
import utils from "../common/utils";
import WebStorage from "../common/web_storage";
import { CAMPAIGN_FILTERS_KEY } from "../common/web_storage_keys";
import InfiniteScroll from "react-infinite-scroll-component";
import { useSnackbar } from "react-simple-snackbar";
import ReportSidebar from "./report-sidebar";
import { ToastContainer, toast } from "react-toastify";
import { FilterDropdown } from "../components/core_component/index.js";
import { max } from "date-fns";
import { use } from "react";

const limit = 10;
const campaignStatusList = [
  "ALL",
  "IN_REVIEW",
  "ACTIVE",
  "COMPLETED",
  "INACTIVE",
  "EXPIRED",
];

const campaignStatusOptions = campaignStatusList.map((status) => ({
  value: status,
  label: status === "ALL" ? "All" : Utils.assignmentStatusToString(status),
}));

const campaignTypeOptions = [
  { value: 'ALL', label: 'All' },
  { value: 'MARKETPLACE', label: 'Marketplace', is_marketplace: 1 },
  { value: 'INHOUSE', label: 'Inhouse', is_marketplace: 0 }
];

const CampaignListingScreen = function (props) {
  const [campaignList, setCampaignList] = useState([]);
  const [loading, setLoading] = useState(true);
  const [openSnackbar] = useSnackbar();
  const [creditsDetail, setCreditsDetail] = useState({});
  const [filterStatus, setFilterStatus] = useState("ALL");
  const [filterCampaignType, setFilterCampaignType] = useState("ALL");
  const [orgData, setOrgData] = useState({});
  const [address, setAddress] = useState({});
  const [openModal, setOpenModal] = useState(false);
  const [brandIsOpen, setBrandIsOpen] = useState(false);
  const [orgId, setOrgId] = useState(null);
  const [brandId, setBrandId] = useState(null);
  const [openOrgBrandListModal, setOpenOrgBrandListModal] = useState(false);
  const [brandList, setBrandList] = useState([]);
  const [selectedBrand, setSelectedBrand] = useState("ALL");
  const [filtersInitialized, setFiltersInitialized] = useState(false);
  const [totalRow, setTotalRow] = useState(0);
  const [currentPage, setCurrentPage] = useState(1);
  const [statusColors] = useState({
    ACTIVE: "#FABC13",
    INACTIVE: "red",
    COMPLETED: "#009A29",
    IN_REVIEW: "#1977f2",
  });

  var navigate = useNavigate();

  useEffect(() => {
    if (!filtersInitialized) return;
    setCurrentPage(1);
    getCampaignListAdmin(1);
  }, [filterStatus, filterCampaignType, selectedBrand, filtersInitialized]);

  const [searchParams, setSearchParams] = useSearchParams();

  // On mount: prefer URL params; otherwise restore from localStorage
  useEffect(() => {
    const sp = Object.fromEntries([...searchParams]);
    if (Object.keys(sp).length > 0) {
      const status = sp.status || "ALL";
      const type = sp.type || "ALL";
      const brand = sp.brand || "ALL";
      setFilterStatus(status);
      setFilterCampaignType(type);
      setSelectedBrand(brand);
      try {
        WebStorage.saveDataInWebStorage(
          CAMPAIGN_FILTERS_KEY,
          JSON.stringify({ status, type, brand })
        );
      } catch (e) {}
      setFiltersInitialized(true);
      return;
    }

    const stored = WebStorage.getDataFromWebStorage(CAMPAIGN_FILTERS_KEY);
    if (stored) {
      try {
        const parsed = JSON.parse(stored);
        const status = parsed.status || "ALL";
        const type = parsed.type || "ALL";
        const brand = parsed.brand || "ALL";
        setFilterStatus(status);
        setFilterCampaignType(type);
        setSelectedBrand(brand);
        const params = {};
        if (status !== "ALL") params.status = status;
        if (type !== "ALL") params.type = type;
        if (brand !== "ALL") params.brand = brand;
        setSearchParams(params);
      } catch (e) {}
    }
    setFiltersInitialized(true);
  }, []);

  function persistFiltersToUrlAndStorage(status, type, brand) {
    const params = {};
    if (status && status !== "ALL") params.status = status;
    if (type && type !== "ALL") params.type = type;
    if (brand && brand !== "ALL") params.brand = brand;
    try {
      setSearchParams(params);
    } catch (e) {}
    try {
      WebStorage.saveDataInWebStorage(
        CAMPAIGN_FILTERS_KEY,
        JSON.stringify({ status, type, brand })
      );
    } catch (e) {}
  }

  useEffect(() => {
    getBrandList();
  }, []);

  function updateProgress(status) {
    setLoading(status);
  }

  function getBrandList() {
    let params = {};
    Core.getBrandList(
      brandListSuccess,
      brandListFailed,
      (status) => {},
      params
    );
  }

  function brandListSuccess(response_data) {
    setBrandList(response_data.brand_list);
  }

  function brandListFailed(errorList) {
    toast.info(errorList.map((item) => item.m).join(", "));
  }

  const openModalOrgList = () => {
    if (openOrgBrandListModal == false) {
      setOpenOrgBrandListModal(true);
    } else {
      setOpenOrgBrandListModal(false);
    }
  };

  function closeOrgBrandListModal() {
    setOpenOrgBrandListModal(false);
  }

  function onSucessOrgBrandModal(brand_id, org_id) {
    console.log("collectionData", org_id, brand_id);
    setOrgId(org_id);
    setBrandId(brand_id);
    setOpenOrgBrandListModal(false);
    navigate(`/create-campaign/${brand_id}`);
  }

  var redux_selector = useSelector((state) => {
    return {
      BrandUser: state.BrandUserDataReducer,
      Auth: state.BrandUserAuthReducer,
    };
  });

  function getCampaignListAdmin(page = 1) {
    var params = {
      start: (page - 1) * limit,
      // limit: limit,
      // brand_id: redux_selector.BrandUser.brand_deep_data.brand_data.brand_id,
    };

    if (filterStatus !== "ALL") {
      params.status = filterStatus;
    }
    
    if (filterCampaignType !== "ALL") {
      params.is_marketplace = filterCampaignType === 'MARKETPLACE' ? 1 : 0;
    }
    
    if (selectedBrand !== "ALL") {
      params.brand_id = selectedBrand;
    }

    Core.getCampaignListAdmin(
      (response) => getCampaignListAdminSuccess(response, page),
      getCampaignListAdminFailed,
      updateProgress,
      params
    );
  }

  function getCampaignListAdminSuccess(response_data, page = 1) {
    console.log("res", response_data);
    setCampaignList(response_data["campaign_list"]);
    setTotalRow(Number(response_data?.pagination_data?.total_count || 0));
    setCurrentPage(page);
  }

  function getCampaignListAdminFailed(errorList) {
    toast.info(errorList.map((item) => item.m).join(", "));
  }

  const handlePageChange = (page) => {
    setCurrentPage(page);
    getCampaignListAdmin(page);
  };

  function getCreditDetail(progress_cb) {
    var params = {};
    Core.getCreditDetail(
      getCreditDetailSuccess,
      getCreditDetailFailed,
      progress_cb,
      params
    );
  }

  function getCreditDetailSuccess(response_data) {
    setCreditsDetail(response_data.credit_data);
  }

  function getCreditDetailFailed(errorList) {
    toast.info(errorList.map((item) => item.m).join(", "));
  }

  function getOrgDataUser(progress_cb) {
    const params = {
      org_id: redux_selector.BrandUser.brand_deep_data.brand_data.org_id,
    };
    Core.getOrgDataUser(
      getOrgDataUserSuccess,
      getOrgDataUserFailed,
      progress_cb,
      params
    );
  }

  function getOrgDataUserSuccess(response_data) {
    setOrgData(response_data.org_data.org_data);
    setAddress(response_data.org_data.address_data.address_premise);
  }

  function getOrgDataUserFailed(errorList) {
    toast.info(errorList.map((item) => item.m).join(", "));
  }

  function CampaignClick(campaignId) {
    navigate(`/campaigns/${campaignId}`);
  }
  const { is_kyc_done, is_verified } = orgData;

  // Custom table data start

  const tableSchema = [
    {
      name: "Campaign Name",
      selector: (row) => row["campaign_data"]["name"],
      // sortable: true,
      maxWidth: "480px",
      cell: (data) => (
        <span
          style={{ textAlign: "left", maxWidth: "480px", display: "block" }}
          onClick={(e) => {
            CampaignClick(data.campaign_data.campaign_id);
            e.stopPropagation();
          }}
        >
          {utils.truncateWithEllipsis(data.campaign_data.name, 60)}
        </span>
      ),
    },

    {
      name: "Brand",
      selector: (row) => row["brand_data"]["name"],
      // sortable: true,
      maxWidth: "300px",
      //cell: (data) => <span>{data.campaign_data.bid_count}</span>,
    },
    {
      name: "Proposals",
      selector: (row) => row["campaign_data"]["bid_count"],
      // sortable: true,
      maxWidth: "121px",
      //cell: (data) => <span>{data.campaign_data.assignment_count}</span>,
    },
    {
      name: "Contracts",
      selector: (row) => row["campaign_data"]["assignment_count"],
      // sortable: true,
      maxWidth: "121px",
      //cell: (data) => <span>{data.campaign_data.assignment_count}</span>,
    },
    {
      name: "Status",
      selector: (row) =>
        utils.assignmentStatusToString(row["campaign_data"]["status"]),
      // sortable: true,
      maxWidth: "195px",
      cell: (data) => (
        <span
          style={{ color: statusColors[data.campaign_data.status] }}
          onClick={(e) => {
            CampaignClick(data.campaign_data.campaign_id);
            e.stopPropagation();
          }}
        >
          {utils.assignmentStatusToString(data.campaign_data.status)}
        </span>
      ),
    },
    {
      name: "Expiring on",
      selector: (row) => utils.formatDate(row["campaign_data"]["end_date"]),
      maxWidth: "149px",
    },

    /*  this function is not returning the date   {
      name: "Expire on",
      selector: (row) => utils.getCampaignType(row["campaign_data"]["end_data"]),
      // sortable: true,
      maxWidth: "149px",
    },*/

    // {
    //   name: "Engagement Type",
    //   selector: (row) =>
    //     utils.engagementType(row["campaign_data"]["engagement_type"]),
    //   // sortable: true,
    //   maxWidth: "200px",
    // },
  ];

  // Define custom styles for table headers
  const customStyles = {
    headRow: {
      style: {
        backgroundColor: "var(--general-secondary-color)", // Change header background color
        color: "var(--gray-gray-300)", // Change header text color
        fontSize: "16px",
        fontWeight: 600,
        lineHight: "19.2px",
        border: "none",
      },
    },
    headCells: {
      style: {
        padding: "10px 0px 10px 20px",
      },
    },
    rows: {
      style: {
        cursor: "pointer",
        fontSize: "16px",
        fontWeight: 400,
        lineHight: "19.2px",
        "&:hover": {
          backgroundColor: "var(--general-secondary-color)",
          fontWeight: 600,
        },
      },
    },
    cells: {
      style: {
        paddingLeft: "20px",
      },
    },
  };

  // custom table data end

  return (
    <div className="dashboard-container">
      <SideMenu />

      <div className="main-screen">
        <Header />
        <div className="page-container-campaignList">
          <div
                className="campaignlist-header"
                style={{ display: "flex", justifyContent: "space-between" }}
              >
                <div>
                  {/* <CampaignListDropdown
                    dropdownItems={campaignStatusList}
                    onItemClick={(item) => {
                      setNext(0);
                      setFilterStatus(item);
                    }}
                  /> */}

                  <div style={{ display: 'flex', gap: '10px' }}>
                    <FilterDropdown
                      label={"Status"}
                      options={campaignStatusOptions}
                      value={filterStatus === "ALL" ? [] : [{ label: filterStatus, value: filterStatus }]}
                      inputType={"singleselect"}
                      onChange={(selectedArray) => {
                        const item = Array.isArray(selectedArray) && selectedArray[0];
                        const status = item ? item.value : "ALL";
                        setFilterStatus(status);
                        persistFiltersToUrlAndStorage(status, filterCampaignType, selectedBrand);
                      }}
                    />
                    <FilterDropdown
                      label={"Delivery Type"}
                      options={campaignTypeOptions}
                      value={filterCampaignType === "ALL" ? [] : [{ label: filterCampaignType, value: filterCampaignType }]}
                      inputType={"singleselect"}
                      onChange={(selectedArray) => {
                        const item = Array.isArray(selectedArray) && selectedArray[0];
                        const type = item ? item.value : "ALL";
                        setFilterCampaignType(type);
                        persistFiltersToUrlAndStorage(filterStatus, type, selectedBrand);
                      }}
                    />
                    <FilterDropdown
                      label={"Brand"}
                      options={[
                        { value: 'ALL', label: 'All Brands' },
                        ...brandList.map(brand => ({
                          value: brand.brand_id,
                          label: brand.name
                        }))
                      ]}
                      value={selectedBrand === "ALL" ? [] : [{
                        value: selectedBrand,
                        label: brandList.find(b => b.brand_id === selectedBrand)?.name || ''
                      }]}
                      inputType={"singleselect"}
                      onChange={(selectedArray) => {
                        const item = Array.isArray(selectedArray) && selectedArray[0];
                        const brandId = item ? item.value : "ALL";
                        setSelectedBrand(brandId);
                        persistFiltersToUrlAndStorage(filterStatus, filterCampaignType, brandId);
                      }}
                      searchEnabled={true}
                    />
                  </div>
                </div>
                <div style={{ marginRight: "20px" }}>
                  <PrimaryCta
                    fontSize={"font_size_large"}
                    fifth
                    text={"Create Campaign"}
                    onClick={openModalOrgList}
                  />
                </div>
              </div>
          {loading ? (
            <div className="loader-mid">
              <Loader />
            </div>
          ) : (
            <>
              

              {campaignList.length !== 0 ? (
                <div className="custom-table">
                  <CustomTable
                    className="CustomTable"
                    tableSchema={tableSchema}
                    tableData={campaignList}
                    paginationPerPage={limit}
                    rowPaddingTop={16}
                    rowPaddingBottom={16}
                    customStyles={customStyles}
                    onRowClicked={(item) =>
                      CampaignClick(item.campaign_data.campaign_id)
                    }
                    pagination
                    paginationServer
                    paginationTotalRows={totalRow}
                    onChangePage={handlePageChange}
                    paginationDefaultPage={currentPage}
                  />
                </div>
              ) : (
                <div className="fallback">
                  <FallBack
                    heading={filterStatus !== 'ALL' 
                      ? `No ${utils.assignmentStatusToString(filterStatus).toLowerCase()} campaigns found`
                      : filterCampaignType !== 'ALL'
                        ? `No ${filterCampaignType.toLowerCase()} campaigns found`
                        : 'No campaigns found'
                    }
                    title={"Launch a new campaign"}
                  />
                <div className="no-campaigns" >

                  <PrimaryCta
                    fifth
                    fontSize="font_size_regular"
                    className="create-campaign"
                    text="Create Campaign"
                    onClick={openModalOrgList}
                  />
                </div>
                </div>
              )}
            </>
          )}
        </div>
        {
          <OrganisationListScreen
            moduleName={"collection-list"}
            onSuccess={onSucessOrgBrandModal}
            openOrgBrandListModal={openOrgBrandListModal}
            closeOrgBrandListModal={closeOrgBrandListModal}
          />
        }
      </div>
    </div>
  );
};

export default CampaignListingScreen;
